import React from 'react';
import { useTranslation } from 'react-i18next';
import { Ripple } from '../utils/PopupRipple.jsx';
import { useChartContext } from '../../contexts/Chart-Context';
import './deposit.scss';

const DepositPromoModal = ({ open, config, onClose, onProceed }) => {
  const { t } = useTranslation();
  const { selectedStyle } = useChartContext();

  if (!open || !config) {
    return null;
  }

  return (
    <div className="deposit-cash deposit-promo-modal" view="true">
      <div className="card">
        <div className="deposit-promo-body">
          <h2 className="deposit-promo-title">{config.title || t('orderPanel.deposit')}</h2>
          {config.message ? (
            <p className="deposit-promo-message">{config.message}</p>
          ) : null}
        </div>
        <div className="row-scss">
          <button
            type="button"
            onClick={onClose}
            style={{
              position: 'relative',
              overflow: 'hidden',
              isolation: 'isolate',
              backgroundColor: selectedStyle.sellColor,
            }}
          >
            <Ripple />
            {t('common.notNow')}
          </button>
          <button
            type="button"
            onClick={onProceed}
            style={{
              position: 'relative',
              overflow: 'hidden',
              isolation: 'isolate',
              backgroundColor: selectedStyle.buyColor,
            }}
          >
            <Ripple />
            {t('orderPanel.deposit')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DepositPromoModal;
